import request from '@/utils/request'

// 获取商场介绍列表
export async function api_getMallDescPage(params) {
  return request({
    url: '/rest/mall/desc/page',
    method: 'get',
    params,
  })
}
// 获取商场介绍详情
export async function api_getMallDesc(params) {
  return request({
    url: '/rest/mall/desc',
    method: 'get',
    params,
  })
}
// 新增商场介绍
export async function api_postMallDesc(data) {
  return request({
    url: '/rest/mall/desc',
    method: 'post',
    data,
  })
}
// 修改商场介绍
export async function api_putMallDesc(data) {
  return request({
    url: '/rest/mall/desc',
    method: 'put',
    data,
  })
}
// 删除商场介绍
export async function api_deleteMallDesc(params) {
  return request({
    url: '/rest/mall/desc',
    method: 'delete',
    params,
  })
}